export const DEFAULT_ERROR_MESSAGE = 'Неизвестная ошибка при отправке первого сообщения';
